import React from 'react';
import { Box, Grid, Tabs, Tab } from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import IniciarSolicitud from '../organisms/IniciarSolicitud';
import EstadoSolicitudes from '../organisms/EstadoSolicitudes';
import useMediaQuery from '@mui/material/useMediaQuery';
import keycloak from '../../Auth/Keycloak';
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

export const TraduccionesSolicitante = () => {
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
    const matches = useMediaQuery('(min-width:600px)');

    const jwt = keycloak.getToken();
    const decodedToken = JSON.parse(atob(jwt.split('.')[1]));
    const userId = decodedToken.sub;

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Grid
            container
            direction="column"
            sx={{
                height: 'auto',
            }}
        >
            <Grid item xs sx={{ height: "auto" }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="fullWidth"
                        textColor="primary"
                        indicatorColor="primary"
                    >
                        <Tab
                            sx={{ paddingTop: '17.5px', paddingBottom: '17.5px' }}
                            label="Iniciar Solicitud"
                            {...a11yProps(0)}
                        />
                        <Tab
                            sx={{ paddingTop: '17.5px', paddingBottom: '17.5px' }}
                            label="Estado de Solicitudes"
                            {...a11yProps(1)}
                        />
                    </Tabs>
                </Box>
            </Grid>
            <Grid item xs>
                <Box sx={{ px: matches ? 2 : 0 }}>
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <IniciarSolicitud />
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <EstadoSolicitudes userId={userId} />
                    </TabPanel>
                </Box>
            </Grid>
        </Grid>
    );
};

export default TraduccionesSolicitante;
